import { supabase } from '../clients/supabaseClient';

export type AccountDeletionStatus = 'pending' | 'confirmed' | 'actioned' | 'expired' | 'cancelled';

export interface AccountDeletionRequest {
    id: string;
    email: string;
    user_id: string | null;
    status: AccountDeletionStatus;
    created_at: string;
    confirmed_at: string | null;
    actioned_at: string | null;
    actioned_by: string | null;
    expires_at: string;
    notes: string | null;
}

// Raw Supabase calls only — no React state, no error formatting.
// Consumed by useAccountDeletionRequests.

export async function fetchAccountDeletionRequests(): Promise<AccountDeletionRequest[]> {
    const { data, error } = await supabase
        .from('account_deletion_requests')
        .select('id, email, user_id, status, created_at, confirmed_at, actioned_at, actioned_by, expires_at, notes')
        .order('created_at', { ascending: false });

    if (error) throw error;
    return data ?? [];
}

export async function actionAccountDeletionRequest(requestId: string): Promise<{ message: string }> {
    const { data, error } = await supabase.functions.invoke('action-account-deletion', {
        body: { requestId },
    });

    if (error) throw error;
    return data;
}